var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24px/bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3171 3.00024C13.7647 3.4417 13.937 4.05188 13.8339 4.62321C16.9616 5.36743 18.4855 8.37003 18.4855 10.7237V15.1276C18.4855 16.3572 19.1899 17.4812 20.3049 18.0311L20.6797 18.2159C20.9658 18.357 21.0818 18.7001 20.9387 18.9822C20.8406 19.1757 20.6401 19.2979 20.4207 19.2979H15.104C14.6522 20.5587 13.433 21.462 12 21.462C10.5669 21.462 9.34773 20.5587 8.8959 19.2979H3.57913C3.25928 19.2979 3 19.0422 3 18.7268C3 18.5104 3.12393 18.3126 3.32013 18.2159L3.69495 18.0311C4.81001 17.4812 5.51436 16.3572 5.51436 15.1276V10.7237C5.51436 8.37029 7.03789 5.36787 10.1653 4.62345C10.0621 4.05205 10.2344 3.44176 10.682 3.00024C11.4097 2.28259 12.5894 2.28259 13.3171 3.00024ZM11.9999 4.31346C11.7407 4.31346 11.4856 4.33119 11.236 4.3655C11.217 4.14843 11.2935 3.92738 11.4578 3.76536C11.757 3.47027 12.2421 3.47027 12.5413 3.76536C12.7055 3.92731 12.7821 4.14826 12.7632 4.3654C12.5137 4.33116 12.2589 4.31346 11.9999 4.31346ZM9.80572 18.2159H8.70861L5.29788 18.2159C6.12495 17.4147 6.61148 16.3076 6.61148 15.1276V10.7237C6.61148 8.33328 8.57626 5.3955 11.9999 5.3955C15.4236 5.3955 17.3884 8.33328 17.3884 10.7237V15.1276C17.3884 16.3076 17.8749 17.4147 18.702 18.2159H15.2913L14.1942 18.2159H9.80572ZM10.0993 19.2979C10.4787 19.9448 11.1878 20.38 12 20.38C12.8121 20.38 13.5212 19.9448 13.9006 19.2979H10.0993Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsLight);
export default __webpack_public_path__ + "static/media/notifications-light.a872df53863d29d318d473856fbdebed.svg";
export { ForwardRef as ReactComponent };